<!-- <router-outlet></router-outlet> -->
<div id="all" *ngIf="datas && (!isVP)" (click)="onClick()" [class]="'fullHD roboto step-'+current">
  <div *ngIf="!isVP && current=='video' && currentVideo" id="video" class="fullHD" (click)="onVideoClick()">
    <!-- <video #video autoplay [src]="base+datasName+'/videos/'+currentVideo" class="fullHD" (ended)="onVideoEnded($event)" (timeupdate)="onTimeupdate($event)" [attr.loop]="loop ? 'loop' : null"></video> -->
    <video #video autoplay [src]="base+datasName+'/assets/'+currentVideo" class="fullHD" [poster]="base+datasName+'/assets/'+getPoster(currentVideo)" (ended)="onVideoEnded($event)"></video>
    <a (click)="onSkipVideo()" class="skip">{{story?.id}}</a>
    <!-- <div class="progressBar"><div class="progressingBar" [style.backgroundColor]="datas.color" [style.width]="videoProgress+'%'"></div></div> -->
  </div>

  <div id="splash" class="page roboto fullHD" *ngIf="current == 'splash'" (click)="onSplashClick()" [style.background]="bgImage">
    <div class="group">
      <div class="title suburban"><span [innerHTML]="datas.title" [style.backgroundColor]="espace.color">...</span></div>
      <div class="baseline">
        <span [innerHTML]="datas.baseline">...</span>
        <span class="picto" *ngIf="espace" [style.backgroundColor]="espace.color">
          <svg width="1em" height="1em" viewBox="0 0 27 33" class="bi bi-play-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path class="st0" d="M12.39,10.74c0-2.09,0.05-4.5-0.03-6.9c-0.03-0.64-0.29-1.52-0.76-1.84c-0.56-0.38-1.65-0.59-2.15-0.3
              C8.83,2.07,8.19,3.03,8.17,3.76c-0.12,4.47-0.05,8.93-0.08,13.4c0,0.46-0.34,0.9-0.52,1.36c-0.37-0.27-0.81-0.5-1.05-0.85
              c-0.55-0.81-0.91-1.74-1.48-2.53c-0.64-0.91-1.6-1.19-2.59-0.66c-1.01,0.55-0.84,1.42-0.41,2.32c2.12,4.51,4.19,9.05,6.36,13.54
              c0.24,0.5,1.04,1.05,1.57,1.05c3.98,0.09,7.94,0.06,11.92,0.05c2-0.02,3.35-1.37,3.37-3.37c0.03-3.8,0.05-7.59-0.03-11.39
              c-0.02-0.67-0.43-1.46-0.91-1.94c-0.37-0.35-1.19-0.47-1.72-0.35c-0.56,0.14-1.05,0.67-1.59,1.05c0.02-1.27,0.06-2.56-1.42-3.16
              c-1.22-0.49-2.01,0.18-2.91,1.16c0.09-1.49,0.06-2.93-1.42-3.26C14.39,10,13.37,10.53,12.39,10.74z"/>
              <path class="st0" d="M12.39,10.74c0.98-0.21,2-0.75,2.87-0.56c1.48,0.32,1.51,1.77,1.42,3.26c0.9-0.96,1.69-1.65,2.91-1.16
              c1.48,0.59,1.42,1.89,1.42,3.16c0.55-0.38,1.02-0.93,1.59-1.05c0.53-0.12,1.36-0.02,1.72,0.35c0.49,0.47,0.9,1.27,0.91,1.94
              c0.09,3.8,0.06,7.59,0.03,11.39c-0.02,2.01-1.37,3.35-3.37,3.37c-3.98,0.03-7.96,0.05-11.92-0.05c-0.55-0.02-1.33-0.55-1.57-1.05
              c-2.16-4.48-4.24-9.02-6.36-13.54c-0.43-0.91-0.59-1.78,0.41-2.32c0.99-0.53,1.95-0.26,2.59,0.66c0.56,0.79,0.93,1.72,1.48,2.53
              c0.24,0.37,0.7,0.58,1.05,0.85c0.18-0.46,0.52-0.9,0.52-1.36c0.05-4.47-0.03-8.93,0.08-13.4c0.02-0.73,0.66-1.69,1.28-2.07
              c0.5-0.3,1.59-0.08,2.15,0.3c0.47,0.32,0.75,1.2,0.76,1.84C12.44,6.25,12.39,8.66,12.39,10.74z"/>
            </g>
          </svg>
        </span>
      </div>
    </div>
  </div>
  <!-- <div class="textFallback absolute full" *ngIf="story && noVideo">
    <div class="inner absolute">
      <div class="table full">
        <div class="cell full">
          <div class="text" [innerHTML]="'<h1>('+story.id+')</h1>'+story.text"></div>
        </div>
      </div>
    </div>
  </div> -->
  <div class="story absolute" *ngIf="story && (noVideo || !videoPlaying)">
    <div class="table full">
      <div class="cell full">
        <ul class="btns suburban">
          <li *ngFor="let button of story.buttons">
            <a (click)="onBtn(button)">
              <div class="table full">
                <div class="cell full" [innerHTML]="button.button"></div>
              </div>
            </a>
          </li>
          <li *ngIf="!this.story.buttons.length">
            <a (click)="goHome()">
              <div class="table full">
                <div class="cell full" [innerHTML]="'FIN'"></div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="game absolute" *ngIf="game">
    <div class="header">
      <div class="title" [innerHTML]="game.title"></div>
      <div class="instruction" [innerHTML]="game.instruction"></div>
    </div>
    <div class="image" *ngIf="(image && (gameStatus == 'playing')) || (image && !correction && (gameStatus != 'playing'))">
      <img [src]="image">
    </div>
    <div class="image correction" *ngIf="correction && (gameStatus != 'playing')">
      <img [src]="correction">
    </div>
    <div class="answers" *ngIf="game.answers">
      <ul>
        <li *ngFor="let answer of game.answers" [class.selected]="answer == selected" [class.text]="answer.text" [class.img]="!answer.text">
          <a (click)="onAnswer(answer)" *ngIf="answer.text" [innerHTML]="answer.text"></a>
          <a (click)="onAnswer(answer)" *ngIf="!answer.text">
            <img [src]="answer.safeImage">
          </a>
        </li>
      </ul>
    </div>
    <div class="footer" *ngIf="!game.answers && gameStatus == 'playing'">
      <a class="btn finish suburban" (click)="onFinish()">Terminé</a>
      <a class="btn_abort suburban" (click)="onAbort()" [innerHTML]="game.btn_skip"></a>
    </div>
    <div class="footer" *ngIf="!game.answers &&  (gameStatus == 'finished' || gameStatus == 'timeout')">
      <p>Validez-vous votre résultat ?</p>
      <a class="btn suburban" (click)="onYes()">Oui</a>
      <a class="btn suburban" (click)="onNo()">Non</a>
    </div>
    <div class="footer" *ngIf="game.answers && gameStatus == 'playing'">
      <a class="btn finish suburban" (click)="onValidate()" [class.disabled]="!selected" [innerHTML]="game.btn_ok"></a>
      <a class="btn_abort suburban" (click)="onAbort()" [innerHTML]="game.btn_skip"></a>
    </div>
    <div *ngIf="timeLeft" class="timeLeft absolute" [innerHTML]="timeLeft"></div>
  </div>
  <a class="homeBtn" (click)="goHome()">
    <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
      <style type="text/css">
        .st0{fill:#FFFFFF;}
      </style>
      <path class="st0" d="M14,15c0.28,0,0.5-0.22,0.5-0.5v-7c0-0.13-0.05-0.26-0.15-0.35l-6-6c-0.2-0.2-0.51-0.2-0.71,0l0,0l-6,6
      C1.55,7.24,1.5,7.37,1.5,7.5v7C1.5,14.78,1.72,15,2,15H14z"/>
    </svg>
  </a>
</div>
<div id="debug" [innerHTML]="debugTxt" *ngIf="debug"></div>
